import { Transition } from './Transition'

type PageRegisteredTransitions = {
  items: Transition[];
};

export const pageRegisteredTransitions: PageRegisteredTransitions = {
  items: [],
};
